<template>
  <el-submenu
    ref="subMenu"
    :index="item.path"
    :popper-append-to-body="false"
  >
    <template slot="title">
      <!-- <vab-icon
        v-if="item && item.meta.icon"
        :icon="['fas', item.meta.icon]"
        class="vab-fas-icon"
      /> -->
      <!-- <vab-remix-icon
        v-if="item.icon "
        :icon-class="item.icon"
        class="vab-remix-icon"
      /> -->
      <span  @click="handleClick(item.path)">{{ item.name }}</span>
    </template>
    <slot />
  </el-submenu>
</template>

<script>
  // import path from 'path'

  export default {
    name: 'VabSubmenu',
    props: {
      routeChildren: {
        type: Object,
        default() {
          return null
        },
      },
      item: {
        type: Object,
        default() {
          return null
        },
      },
      fullPath: {
        type: String,
        default: '',
      },
    },
  methods: {
    handleClick(path) { 
      if (this.$route.path == path) { 
        return
      }
      this.$router.push(path)
    },
    // isExternal(path) {
    //   return /^(https?:|mailto:|tel:)/.test(path)
    // },
      // handlePath(routePath) {
      //   if (this.isExternal(routePath)) {
      //     return routePath
      //   }
      //   if (this.isExternal(this.fullPath)) {
      //     return this.fullPath
      //   }
      //   return path.resolve(this.fullPath, routePath)
      // },
    },
  }
</script>
